import { ulid } from "ulid"
import { createActionUtils, IAction, IActionJavaData, IActionWebConfig } from "@droid/project-v2-interface"
import { scriptActionNamespace } from "../script-namespace"
import { IActionScriptUI } from "./IActionScript.UI"
import { Log } from "@fanfanlo"

const fileLog = new Log(false, '[IActionScript]')
fileLog.pause = true
fileLog.childrenPaused = true

const type = `${scriptActionNamespace}script`
fileLog.log('[IActionScript] type:', type)

export interface IActionScriptJavaData extends IActionJavaData {
    script: string
    scriptMode: 'simple' | 'advanced' | 'full'
}

export interface IActionScriptWebConfig extends IActionWebConfig {
    // Script Action 特有的 Web 配置
}

export interface IActionScriptData extends IAction<IActionScriptJavaData, IActionScriptWebConfig> {
    javaData: IActionScriptJavaData
}

function createDefaultData(): IActionScriptData {
    fileLog.log('[createDefaultData] 开始创建默认数据')

    const ulidValue = ulid()
    fileLog.log('[createDefaultData] 生成ulid:', ulidValue)

    const defaultData: IActionScriptData = {
        
        ulid: ulidValue,
        uuid: '',
        ownerUuid: '',
        currentVersion: 0,
        type,
        name: 'actionScript',
        javaData: {
            script: '',
            scriptMode: 'simple'
        },
        createdAt: 0,
        updatedAt: 0,
        authorUuid: '',
    }
    fileLog.log('[createDefaultData] defaultData:', JSON.stringify(defaultData))
    return defaultData
}

function init() {
    fileLog.log('[init] script-action 初始化')
}

export const actionScriptUtils = createActionUtils(type, init, createDefaultData, IActionScriptUI)
